/** Information step — read-only content with no interaction, rendered as a calm reading moment. */
import { useSession } from '../SessionContext';
import { StepShell } from './StepShell';
import {
  PromptRenderer,
  type TiptapNode,
  type MediaItem,
} from '@/shared/components/PromptRenderer';
import { normaliseMediaRefs } from '../utils/normaliseMediaRefs';

/**
 * Information step — no interaction, just renders prompt with generous typography.
 * A calm reading moment between interactive steps.
 */
interface DiagramJson {
  syntax: string;
  diagramType?: string;
}

export function InfoStep() {
  const { currentStep } = useSession();
  if (!currentStep) return null;

  const snapshot = currentStep.stepSnapshotPublicJson;
  const mediaItems: MediaItem[] | null = normaliseMediaRefs(currentStep.mediaRefsJson);

  const diagramJson = (currentStep as unknown as Record<string, unknown>)?.diagramJson as
    | DiagramJson
    | null
    | undefined;

  return (
    <StepShell>
      <PromptRenderer
        doc={snapshot.prompt as TiptapNode}
        media={mediaItems}
        diagramJson={diagramJson ?? null}
        visualPosition="below"
      />
    </StepShell>
  );
}
